<div class="report-card-content">
  <h4 class="header" style="margin-bottom: 16px" [style.color]="value != null ? '#495056' : '#ACB4BB'">{{header}}</h4>
  <div class="__index-dot-group">
    <awair-index-dot
      style="margin-right: 6px;"
      [color]="indexColor"
      [width]="10"
      [height]="10">
    </awair-index-dot>
    <span class="dot-label" [style.color]="indexColor">{{condition | namize}}</span>
  </div>
  <div *ngIf="value != null">
    <h3 class="value">{{value | number: '1.1-1'}} <span class="unit">{{unit}}</span></h3>
    <span class="percentage">{{percentage}}</span>
  </div>
</div>
